// import axios from '../plugins/axios'
const state = {
  add_job_modal : false,
  edit_job_modal: false,
  id: null,
  is_view_mode: null,
  last_add_job_id: null,
}
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key]
  }
}
const  actions = {

}
const mutations = {
  setJobData(state,data){
    state[data.key] = data.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}